import * as React from 'react';

import SidebarHeader from 'coaching/components/SidebarHeader';
import CoachingBillingStripe from 'coaching/components/CoachingBillingView/CoachingBillingStripe';
import CoachingStripeContainer from 'coaching/components/CoachingStripeContainer';
import { coachingBillingViewPrefix } from 'coaching/components/CoachingBillingView/CoachingBillingView';

import { CoachingbillingCardDetailType } from './types';

type Props = {
  onClose: () => void;
  cardDetail?: CoachingbillingCardDetailType;
};

export default function CoachingBillingCardSidebar(props: Props) {
  const { onClose, cardDetail } = props;
  return (
    <>
      <SidebarHeader
        title="Update payment"
        onClose={onClose}
        closeEvent={`${coachingBillingViewPrefix}.coaching_billing_sidebar_card.exit_close.click`}
      />
      <CoachingStripeContainer>
        <CoachingBillingStripe onCloseSideBar={onClose} cardDetail={cardDetail} />
      </CoachingStripeContainer>
    </>
  );
}
